import { AccountServices } from './account-services'
import { CompanyServices } from './company-services'

import { ApiBase } from './api-base'
import { UserServices } from './users-service'
import { EmployeeServices } from './employee-services'
import { AttachmentServices } from './attachment-services'
import { RequestsServices } from './requests-services'
import { ImportServices } from './import-services'

export const officeServices = new ApiBase({
  resource: '/api/v1/accounts/offices',
  name: 'office',
  successPath: '/offices'
})

export const assetServices = new ApiBase({
  resource: '/api/v1/contractor/assets',
  name: 'asset',
  successPath: '/company_assets'
})

export const contractServices = new ApiBase({
  resource: '/api/v1/contractor/contracts',
  name: 'contract',
  successPath: '/contracts'
})

export const cityServices = new ApiBase({
  resource: '/api/v1/cities',
  name: 'city'
})

export const dashboardServices = new ApiBase({
  resource: '/api/v1/dashboard',
  name: 'dashboard'
})

export const employeeServices = new EmployeeServices()
export const companyServices = new CompanyServices()
export const accountServices = new AccountServices()
export const userServices = new UserServices()
export const attachmentServices = new AttachmentServices()
export const requestsServices = new RequestsServices()
export const importServices = new ImportServices()
